var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"img-wrap"},_vm._l((_vm.pdfImages),function(img,i){return _c('img',{key:i,attrs:{"src":img}})}),0)]),(_vm.showBtn)?_c('div',{staticClass:"btns"},[_c('van-button',{attrs:{"type":"info","size":"small"},on:{"click":_vm.goBack}},[_vm._v("返回上一页")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }